import type { SendTask } from "@/lib/runs";
import { formatClock, formatDay, formatGap, formatTook } from "@/lib/task-timing";

/**
 * Cột thời gian của một dòng gửi: gửi lúc mấy giờ, tốn bao lâu, cách tin trước
 * bao lâu.
 *
 * Khoảng cách với tin trước là con số quan trọng nhất ở đây — nó cho thấy nhịp
 * THỰC TẾ đang chạy. Một chiến dịch đứng im vì chạm trần giờ nhìn y hệt một
 * chiến dịch hỏng, cho tới khi thấy khoảng cách nhảy từ 7 giây lên 50 phút.
 */
export function TaskTiming({
    task,
    previousFinishedAt,
    showDay,
}: {
    task: SendTask;
    previousFinishedAt: string | null;
    showDay: boolean;
}) {
    // Chưa gửi thì chưa có gì để nói — giữ chỗ để các cột bên phải không nhảy
    if (!task.finishedAt) return <span className="w-28 shrink-0" aria-hidden />;

    const gap = formatGap(task.finishedAt, previousFinishedAt);
    const took = formatTook(task.durationMs);

    return (
        <span className="flex shrink-0 items-baseline gap-2 text-xs tabular-nums text-ink-muted">
            {showDay && <span className="hidden sm:inline">{formatDay(task.finishedAt)}</span>}

            <span className="text-ink" title={new Date(task.finishedAt).toLocaleString("vi-VN")}>
                {formatClock(task.finishedAt)}
            </span>

            {took && <span className="hidden w-10 text-right sm:inline">{took}</span>}
            {gap && (
                <span className="hidden w-12 text-right md:inline" title="Cách tin gửi trước đó">
                    {gap}
                </span>
            )}
        </span>
    );
}
